import {
  Card,
  CardContent,
  Typography,
  Grid2 as Grid,
  Box,
  Fade,
  Slide,
} from "@mui/material";

import QuickActionPermit from "./quickActionsComponents/QuickActionPermit";
import QuickActionValidateLicense from "./quickActionsComponents/QuickActionValidateLicense";
import { useState } from "react";
import ContractorSlip from "./quickActionsComponents/ContractorSlip";
import QuickActionIcons from "./quickActionsComponents/QuickActionIcons";
import { useSelector } from "react-redux";
import QuickActionContractorCard from "./quickActionsComponents/QuickActionContractorCard";

const QuickActions = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);

  const [foundContractor, setFoundContractor] = useState(null);

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography
          variant="h5"
          textAlign="center"
          gutterBottom
          fontWeight="bold"
        >
          Quick Actions
        </Typography>

        <Grid container mt={{ xs: 2, sm: 6 }} spacing={{ xs: 1.5, sm: 2 }}>
          <Grid size={{ xs: 12, md: 4 }}>
            <QuickActionPermit />
          </Grid>
          <Grid
            size={{ xs: 12, md: 4 }}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: { xs: 2, sm: 10 },
            }}
          >
            <Box
              sx={{
                position: "relative",
                height: "100%",
                display: "flex",
                alignItems: "center", // vertical center
                justifyContent: "center", // horizontal center
              }}
            >
              {/* Floating contractor slip */}
              <Box
                sx={{
                  position: "absolute",
                  zIndex: foundContractor ? 99999 : undefined,
                  top: { xs: 10, sm: 35 },
                  left: { xs: 8, sm: 10 },
                  right: { xs: 8, sm: -20 },
                }}
              >
                <Fade in={!!foundContractor} timeout={300}>
                  <Slide direction="left" in={!!foundContractor} timeout={400}>
                    <div>
                      <ContractorSlip foundContractor={foundContractor} />
                    </div>
                  </Slide>
                </Fade>
              </Box>

              {/* Centered Icon Grid */}
              <QuickActionIcons />
            </Box>
          </Grid>

          {/* Private Provider only */}
          {currentSession === "privateProviderSession" ? (
            <Grid size={{ xs: 12, md: 4 }} sx={{ position: "relative" }}>
              <QuickActionValidateLicense
                foundContractor={foundContractor}
                setFoundContractor={setFoundContractor}
              />
            </Grid>
          ) : (
            <Grid size={{ xs: 12, md: 4 }}>
              <QuickActionContractorCard />
            </Grid>
          )}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default QuickActions;
